import { BrowserRouter } from "react-router-dom";
import { Notifications } from "@mantine/notifications";
import AppRoutes from "./routes";
import { UserProvider } from "@/context/UserContext";
import { ScrollToTop } from "./components/ScrollToTop";

// Mantine theme configuration
function App() {
  return (
    <>
      <Notifications position="bottom-right" zIndex={1000} />
      <BrowserRouter>
        <UserProvider>
          <ScrollToTop />
          <AppRoutes />
        </UserProvider>
      </BrowserRouter>
    </>
  );
}

export default App;
